<template>
	<div class="test">
		<!-- large view for offer create step/edit 4 -->
		<!-- ATTENTION: do not use with references. -->
		<!-- grid lg:grid-cols-3 gap-x-6 gap-y-6 -->

		<div v-if="largeView" class="space-y-2">
			<div class="grid grid-cols-3">
				<h4 class="text-sm text-gray-900">{{ __("Article") }}</h4>
				<p class="col-span-2 text-sm">
					<!-- {{ __(tradeLabel) }}<br> -->
					{{ __(productLabelLight) }}
					<br />
					{{ __(originLabel) }}
					<br />
					{{ __("Harvest") }} {{ offer.product.harvest || __("n.a.") }}
				</p>
			</div>

			<!-- Quality -->
			<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
				<h4 class="text-sm text-gray-900">{{ __("Quality") }}</h4>
				<p class="col-span-2 text-sm">
					<crop-quality-summary
						:tradable="offer"
						:referenceTradable="reference"
					/>
				</p>
			</div>

			<!-- Quantity -->
			<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
				<h4 class="text-sm text-gray-900">{{ __("Quantity") }}</h4>
				<p class="col-span-2 text-sm">
					<span v-if="offer.qty.tolerance == 'TOLERANCE_CA'"
						>ca. {{ offer.qty.mt }} t</span
					>
					<span v-else>
						{{ offer.qty.mt }} t,
						{{
							$cropOptions.getLocalizedLabel(
								offer.qty.tolerance,
								$cropOptions.qtyToleranceOptions
							)
						}}
						{{ __("Tolerance") }}
					</span>
					<br />
					<span v-if="offer.qty.partial_ok">{{
						__("Partial quantity possible")
					}}</span>
					<span
						v-html="
							maybeStrikethrough(
								reference ? reference.qty.mt : null,
								offer.qty.mt,
								't'
							)
						"
					/>
				</p>
			</div>

			<!-- Price -->
			<div class="grid grid-cols-3 border-t border-gray-200 pt-2">
				<h4 class="text-sm text-gray-900">{{ __("Price") }}</h4>

				<p v-if="offer.price.type == 'FLAT'" class="text-sm col-span-2">
					<span v-if="offer.price.mt"
						>{{ $cropOptions.formatLocalizedNumber(offer.price.mt) }} €/t</span
					>
					<i v-else>{{ __("not provided") }}</i>

					<span
						v-if="
							!match ||
							!reference ||
							!(
								user &&
								user.type == 'FARMER' &&
								reference.location.mode == 'DAP' &&
								offer.location.mode == 'FCA' &&
								match.price_estimate == offer.price.mt
							)
						"
						v-html="
							maybeStrikethrough(
								reference
									? $cropOptions.formatLocalizedNumber(reference.price.mt)
									: null,
								$cropOptions.formatLocalizedNumber(offer.price.mt),
								'€/t'
							)
						"
					/>
				</p>

				<p v-else-if="offer.price.type == 'INDEXED'" class="text-sm col-span-2">
					<span v-if="currentIndexedPrice">
						{{ __("Currently") }}:
						{{ $cropOptions.formatLocalizedNumber(currentIndexedPrice) }} €/t
						<br />
					</span>
					<span
						v-html="
							maybeStrikethrough(
								reference
									? $cropOptions.formatLocalizedNumber(reference.price.mt)
									: null,
								$cropOptions.formatLocalizedNumber(offer.price.mt),
								'€/t'
							)
						"
					/>
					<span
						>{{ __("Premium based") }}: {{ offer.price.basis > 0 ? "+" : ""
						}}{{ $cropOptions.formatLocalizedNumber(offer.price.basis) }} €/t
						{{ localCommodityFuture.name }}</span
					>
				</p>

				<p v-else-if="offer.price.type == 'BASIS'" class="text-sm col-span-2">
					{{ __("Premium") }}
					{{ $cropOptions.formatLocalizedNumber(offer.price.basis) }} €/t
					{{ localCommodityFuture.name }})
				</p>

				<p v-else-if="offer.price.type == 'NONE'" class="text-sm col-span-2">
					<i>{{ __("not provided") }}</i>
				</p>
			</div>

			<!-- Fulfilment Date -->
			<div
				v-if="offer.date.type != null"
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
			>
				<h4 class="text-sm text-gray-900">{{ __("Fulfilment Date") }}</h4>
				<p class="text-sm col-span-2">
					{{ options.dateToString(offer, locale) }}
					<span
						v-html="
							maybeStrikethrough(
								reference ? options.dateToString(reference, locale) : null,
								options.dateToString(offer, locale)
							)
						"
					/>
				</p>
			</div>

			<!-- Location -->
			<div
				v-if="options.locationToString(offer) != ''"
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
			>
				<h4 class="text-sm text-gray-900">{{ __("Location") }}</h4>
				<p class="text-sm col-span-2">
					{{
						$cropOptions.getLocalizedLabel(
							offer.location.mode,
							$cropOptions.locationModeOptions
						)
					}}
					<span
						v-if="offer.location.optional_transport"
						:class="[!offer.visible ? 'text-gray-300' : 'text-gray-500']"
						>({{ __("Transportation possible") }})</span
					>
					<br />
					{{ offer.location.address.zip }} {{ offer.location.address.city }}
				</p>
			</div>

			<!-- Contract conditions -->

			<div
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
				v-if="offer.extra.contract != null && offer.extra.contract != ''"
			>
				<h4 class="text-sm text-gray-900 hyphens">
					{{ __("Contract Conditions") }}
				</h4>
				<p class="text-sm col-span-2">
					<span v-html="contractTerms" />
				</p>
			</div>

			<!-- Payment conditions -->
			<div
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
				v-if="
					offer.extra.payment_terms != null && offer.extra.payment_terms != ''
				"
			>
				<h4 class="text-sm text-gray-900 hyphens">
					{{ __("Payment Conditions") }}
				</h4>
				<p class="text-sm col-span-2">
					{{
						__(
							options.getLabel(
								offer.extra.payment_terms,
								options.paymentTermsOptions
							)
						) || __("not provided")
					}}
					<!-- :-( -->
					<span
						v-html="
							maybeStrikethrough(
								__(
									options.getLabel(
										reference ? reference.extra.payment_terms : null,
										options.paymentTermsOptions
									)
								),
								__(
									options.getLabel(
										offer.extra.payment_terms,
										options.paymentTermsOptions
									)
								)
							)
						"
					/>
				</p>
			</div>

			<!-- Payment method -->
			<div
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
				v-if="
					offer.extra.payment_mode != null && offer.extra.payment_mode != ''
				"
			>
				<h4 class="text-sm text-gray-900">{{ __("Payment Method") }}</h4>

				<p class="text-sm col-span-2">
					{{
						__(
							options.getLabel(
								offer.extra.payment_mode,
								options.paymentModeOptions
							)
						) || __("not provided")
					}}
					<span
						v-html="
							maybeStrikethrough(
								__(
									options.getLabel(
										reference ? reference.extra.payment_mode : null,
										options.paymentModeOptions
									)
								),
								__(
									options.getLabel(
										offer.extra.payment_mode,
										options.paymentModeOptions
									)
								)
							)
						"
					/>
				</p>
			</div>

			<!-- Extra -->
			<div
				v-if="showExtraTextRow"
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
			>
				<h4 class="text-sm text-gray-900">{{ __("Additional conditions") }}</h4>
				<span class="col-span-2">
					<p class="text-sm">
						{{ averageAcrossDeliveries(offer) }}
						<span
							v-html="
								maybeStrikethrough(
									reference ? averageAcrossDeliveries(reference) : null,
									averageAcrossDeliveries(offer)
								)
							"
						/>
					</p>
					<p class="text-sm">
						<span class="whitespace-pre-line">{{ offer.extra.text }}</span>
						<span class="line-through text-red-600" v-if="extraTextIsRemoved">{{
							reference.extra.text
						}}</span>
						<span
							class="font-italic text-red-600"
							v-else-if="extraTextIsChanged"
							>{{ __("(changed!)") }}</span
						>
					</p>
					<span v-if="offer.variety_protection_enabled">
						<p class="flex items-center">
							{{ __("EU Plant Variety Protection") }}
							<ui-tooltip
								class="text-green-400 whitespace-normal"
								:icon-stroke-width="2"
								icon-class="ml-1 w-4 h-4"
								:text="euVarietyProtectionInfo"
							/>
						</p>
					</span>
				</span>
			</div>

			<!-- Extra & expiryOption -->
			<div
				v-if="offer.extra && offer.extra.expiry_option"
				class="grid grid-cols-3 border-t border-gray-200 pt-2"
			>
				<h4 class="text-sm text-gray-900">{{ __("Validity") }}</h4>
				<p class="text-sm">
					{{
						__(
							options.getLabel(
								offer.extra.expiry_option,
								options.bidExpiryOptions
							)
						)
					}}
					<span v-if="offer.expires_at"
						>({{ __("until") }} {{ offer.expires_at }})</span
					>
				</p>
			</div>
		</div>

		<!-- legacy view -->
		<table v-else class="table-sm x-vue--terms-summary">
			<tr v-if="offer.type == 'BID'">
				<td class="pr-2">{{ __(offer.meta.counterpart_label) }}</td>
				<td>{{ offer.counterpart.company_name }}</td>
			</tr>
			<tr v-if="offer.type == 'CONTRACT'">
				<td class="pr-2">{{ __("Buyer") }}</td>
				<td>{{ offer.buyer.company_name }}</td>
			</tr>
			<tr v-if="offer.type == 'CONTRACT'">
				<td class="pr-2">{{ __("Seller") }}</td>
				<td>{{ offer.seller.company_name }}</td>
			</tr>
			<tr>
				<td class="pr-2">{{ __("Article") }}</td>
				<td>
					{{ __(tradeLabel) }}
					{{ __(productLabel) }}, {{ __("Harvest year") }}
					{{ offer.product.harvest || __("n.a.") }}
				</td>
			</tr>
			<tr v-if="!qualityIsEmpty">
				<td class="pr-2">{{ __("Quality") }}</td>
				<td>
					<crop-quality-summary
						:tradable="offer"
						:referenceTradable="reference"
						:showReferenceStrikethrough="offer.type != 'OFFER'"
					/>
				</td>
			</tr>
			<tr v-if="offer.qty.mt != null">
				<td class="pr-2">{{ __("Quantity") }}</td>
				<td>
					<span v-if="offer.qty.tolerance == 'TOLERANCE_CA'"
						>ca. {{ offer.qty.mt }} t</span
					>
					<span v-else>
						{{ offer.qty.mt }} t,
						<br />
						{{
							$cropOptions.getLocalizedLabel(
								offer.qty.tolerance,
								$cropOptions.qtyToleranceOptions
							)
						}}
						{{ __("Tolerance") }}
					</span>
					<div v-if="offer.qty.partial_ok">
						{{ __("Partial quantity possible") }}
					</div>
					<span
						v-html="
							maybeStrikethrough(
								reference ? reference.qty.mt : null,
								offer.qty.mt,
								't'
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="offer.price.type == 'BASIS'">
				<td class="pr-2">{{ __("Price") }}</td>
				<td>
					{{ __("Premium") }} {{ offer.price.basis }} €/t
					{{ localCommodityFuture.name }})
				</td>
			</tr>
			<tr v-else-if="offer.price.mt || offer.type == 'BID'">
				<td class="pr-2">{{ __("Price") }}</td>
				<td>
					<span v-if="offer.price.mt">
						{{ offer.price.mt }} €/t
						<span
							v-html="
								maybeStrikethrough(
									reference ? reference.price.mt : null,
									offer.price.mt,
									'€/t'
								)
							"
						/>
						<span v-if="offer.price.type == 'INDEXED'"
							>({{ __("Premium based") }}: {{ offer.price.basis > 0 ? "+" : ""
							}}{{ offer.price.basis }} €/t
							{{ (localCommodityFuture || offer.commodity_future).name }})</span
						>
					</span>
					<span v-else-if="offer.price.type == 'INDEXED'">{{
						__("Currently no price available for this real-time bid.")
					}}</span>
					<i v-else>{{ __("not provided") }}</i>
				</td>
			</tr>

			<tr v-if="offer.date.type != null">
				<td class="pr-2">{{ __("Fulfilment Date") }}</td>
				<td>
					{{ options.dateToString(offer, locale) }}
					<span
						v-html="
							maybeStrikethrough(
								reference ? options.dateToString(reference, locale) : null,
								options.dateToString(offer, locale)
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="options.locationToString(offer) != ''">
				<td class="pr-2">{{ __("Location") }}</td>
				<td>
					{{ options.locationToString(offer) }}
					<span
						v-if="
							offer.reference && offer.reference.price_indication_id != null
						"
					>
						<!-- do not show location reference for price indication -->
					</span>
					<span
						v-else
						v-html="
							maybeStrikethrough(
								reference ? options.locationToString(reference) : null,
								options.locationToString(offer)
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="extended">
				<td class="pr-2">{{ __("Contract Conditions") }}</td>
				<td>
					<span v-html="contractTerms" />
					<span
						class="line-through text-red-600"
						v-html="referenceTerms"
						v-if="contractTerms != referenceTerms"
					></span>
					<p class="text-small mt-0" v-if="showRapeExtra">
						{{
							__(
								"Cost/application of analyses according to oil mill conditions or receiving station."
							)
						}}
					</p>
				</td>
			</tr>
			<tr v-if="extended">
				<td></td>
				<td>
					{{ averageAcrossDeliveries(offer) }}
					<span
						v-html="
							maybeStrikethrough(
								reference ? averageAcrossDeliveries(reference) : null,
								averageAcrossDeliveries(offer)
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="extended">
				<td class="pr-2">{{ __("Payment Conditions") }}</td>
				<td>
					{{
						__(
							options.getLabel(
								offer.extra.payment_terms,
								options.paymentTermsOptions
							)
						) || __("not provided")
					}}
					<span
						v-html="
							maybeStrikethrough(
								__(
									options.getLabel(
										reference ? reference.extra.payment_terms : null,
										options.paymentTermsOptions
									)
								),
								__(
									options.getLabel(
										offer.extra.payment_terms,
										options.paymentTermsOptions
									)
								)
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="extended">
				<td class="pr-2">{{ __("Payment Method") }}</td>
				<td>
					{{
						__(
							options.getLabel(
								offer.extra.payment_mode,
								options.paymentModeOptions
							)
						) || __("not provided")
					}}
					<span
						v-html="
							maybeStrikethrough(
								__(
									options.getLabel(
										reference ? reference.extra.payment_mode : null,
										options.paymentModeOptions
									)
								),
								__(
									options.getLabel(
										offer.extra.payment_mode,
										options.paymentModeOptions
									)
								)
							)
						"
					/>
				</td>
			</tr>
			<tr v-if="showExtraTextRow" class="font-weight-bold">
				<td class="pr-2">{{ __("Additional conditions") }}</td>
				<td>
					{{ offer.extra.text }}
					<span
						class="line-through text-red-600 whitespace-pre-line"
						v-if="extraTextIsRemoved"
						>{{ reference.extra.text }}</span
					>
					<span
						class="font-italic text-red-600"
						v-else-if="extraTextIsChanged"
						>{{ __("(changed!)") }}</span
					>
					<div v-if="offer.variety_protection_enabled">
						<p class="flex items-center">
							{{ __("EU Plant Variety Protection") }}
							<ui-tooltip
								class="text-green-400 whitespace-normal"
								:icon-stroke-width="2"
								icon-class="ml-1 w-4 h-4"
								:text="euVarietyProtectionInfo"
							/>
						</p>
					</div>
				</td>
			</tr>

			<tr v-if="offer.extra && offer.extra.expiry_option">
				<td class="pr-2">{{ __("Validity") }}</td>
				<td>
					{{
						__(
							options.getLabel(
								offer.extra.expiry_option,
								options.bidExpiryOptions
							)
						)
					}}
					<span v-if="offer.expires_at"
						>({{ __("until") }} {{ offer.expires_at }})</span
					>
				</td>
			</tr>
		</table>
	</div>
</template>

<script>
let options = require("../cropOptions.js");

export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		reference: {
			type: Object,
			required: false,
		},
		extended: {
			type: Boolean,
			required: false,
			default: false,
		},
		customTradeLabel: {
			type: String,
			required: false,
		},
		largeView: {
			type: Boolean,
			required: false,
			default: false,
		},
		commodityFuture: {
			type: Object,
			required: false,
		},
		match: {
			type: Object,
			required: false,
			default: null,
		},
		user: {
			type: Object,
			required: false,
		},
	},
	computed: {
		tradeLabel: function () {
			if (this.customTradeLabel) {
				return this.customTradeLabel;
			} else if (this.offer.trade) {
				return this.__(this.offer.trade == "BUY" ? "Request" : "Sell offer");
			} else {
				return "";
			}
		},
		euVarietyProtectionInfo: function () {
			return this.__("eu_variety_protection_info");
		},
		productLabel() {
			return (
				this.offer.product.origin +
				" " +
				this.__(
					this.getLabel(
						this.offer.product.grade,
						this.options.productGradeOptions
					) ||
						this.getLabel(
							this.offer.product.type,
							this.options.productTypeOptions
						)
				)
			);
		},
		productLabelLight() {
			return this.__(
				this.getLabel(
					this.offer.product.grade,
					this.options.productGradeOptions
				) ||
					this.getLabel(
						this.offer.product.type,
						this.options.productTypeOptions
					)
			);
		},
		originLabel() {
			return this.__(
				this.getLabel(this.offer.product.origin, this.options.originOptions) ||
					this.getLabel(this.offer.product.origin, this.options.originOptions)
			);
		},
		contractTerms() {
			return this.contractToString(this.offer);
		},
		referenceTerms() {
			return this.contractToString(this.reference);
		},
		qualityIsEmpty() {
			let isEmpty = !Object.values(this.offer.quality).some(
				(x) => x !== null && x !== ""
			);
			return isEmpty;
		},
		showRapeExtra() {
			return (
				this.offer.product.type == "RAPE" &&
				!(this.offer.type == "BID" && this.offer.trade == "SELL")
			);
		},
		showExtraTextRow() {
			return (
				this.offer.extra.text != null ||
				this.offer.extra.average_across_deliveries == true ||
				(this.reference && this.reference.extra.text != null) ||
				this.offer.variety_protection_enabled != null
			);
		},
		extraTextIsRemoved() {
			if (this.reference && this.reference.extra.text != null) {
				return this.offer.extra.text == null || this.offer.extra.text == "";
			} else {
				return false;
			}
		},
		extraTextIsChanged() {
			if (this.reference && this.reference.extra.text != null) {
				return this.offer.extra.text != this.reference.extra.text;
			} else {
				return false;
			}
		},
		localCommodityFuture() {
			if (this.commodityFuture) {
				return this.commodityFuture;
			} else if (this.offer.commodityFuture) {
				return this.offer.commodityFuture;
			} else {
				return this.offer.commodity_future;
			}
		},
		currentIndexedPrice() {
			let indexPrice = 1 * this.localCommodityFuture.euronext_price,
				basis = 1 * this.offer.price.basis;

			if (indexPrice && basis) {
				return indexPrice + basis;
			} else {
				return null;
			}
		},
	},
	data() {
		return {
			options: options,
		};
	},
	methods: {
		getLabel(what, where) {
			return options.getLabel(what, where);
		},
		maybeStrikethrough(ref, now, suffix = "") {
			if (ref == null || ref == "") {
				return "";
			} else if (ref == now) {
				return "";
			} else {
				return `<span class="line-through text-red-600">${ref} ${suffix}</span>`;
			}
		},
		contractToString(tradable) {
			if (!tradable) {
				return "";
			} else if (tradable.extra.contract == "EHB") {
				return this.__("Standard conditions");
			} else if (tradable.extra.contract == "EHB_CUSTOM") {
				return this.__(`Standard conditions based on buy-out conditions`);
			} else {
				return this.__("not provided");
			}
		},
		averageAcrossDeliveries(tradable) {
			return tradable.extra.average_across_deliveries
				? this.__("Billing in the average of the total lot")
				: "";
		},
	},
};
</script>

<style scoped>
.hyphens {
	-webkit-hyphens: auto;
	-ms-hyphens: auto;
	hyphens: auto;
}
</style>
